import Fuse from 'fuse.js';
import axios from 'axios';
import Select from '../../components/select/select';
import SearchBox from '../../components/searchBox/searchBox';

export default class News {
    constructor() {
        this.postsHolder = document.querySelector('.newsHolder');
        this.searchBox = new SearchBox(document.querySelector('.searchBox'));
        this.categorySelect = new Select(
            document.querySelector('.select[data-id="categories"]')
        );
        this.showAllButton = document.querySelector(
            '.news__loadMoreholder .button'
        );
        this.posts = [];

        this.showAll = false;
        this.currentSearch = '';
        this.currentCategory = 'all';

        this.getposts();
        this.bindEvents();
    }

    bindEvents() {
        this.showAllButton.addEventListener('click', () => this.showAllItems());
        this.searchBox.on('search', keyword => this.searchHandler(keyword));
        this.categorySelect.on('changed', value => this.filterHandler(value));
    }

    showAllItems() {
        this.hideShowAllButton();

        const html = this.getHtml(this.posts.slice(8, this.posts.length));
        this.postsHolder.insertAdjacentHTML('beforeend', html);
    }

    hideShowAllButton() {
        if (!this.showAll) {
            this.showAllButton.parentNode.style.display = 'none';
            this.showAll = true;
        }
    }

    searchHandler(keyword) {
        this.hideShowAllButton();
        this.currentSearch = keyword;
        this.filterAndSearch();
    }

    filterHandler(value) {
        this.hideShowAllButton();
        this.currentCategory = value;
        this.filterAndSearch();
    }

    filterAndSearch() {
        let posts = this.posts;

        if (this.currentSearch.length > 0) {
            posts = this.search(posts);
        }

        if (this.currentCategory !== 'all') {
            posts = this.filter(posts);
        }

        this.render(posts);
    }

    filter(items) {
        const filtered = [];

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (this.hasCurrentCategory(item)) {
                filtered.push(item);
            }
        }

        return filtered;
    }

    hasCurrentCategory(item) {
        const categories = item.categories;

        for (let i = 0; i < categories.length; i++) {
            if (categories[i].slug === this.currentCategory) {
                return true;
            }
        }

        return false;
    }

    search(items) {
        const options = {
            threshold: 0.3,
            shouldSort: true,
            tokenize: true,
            keys: [
                {
                    name: ['name']
                }
            ]
        };

        const fuse = new Fuse(items, options);
        const results = fuse.search(this.currentSearch);

        return results;
    }

    getposts() {
        const self = this;

        axios
            .get('/news')
            .then(function(response) {
                self.posts = response.data;
                if (self.posts.length > 8) {
                    self.showAllButton.parentNode.style.display = 'block';
                }
                self.render(self.posts.slice(0, 8));
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render(posts) {
        const html = this.getHtml(posts);
        this.postsHolder.innerHTML = html;
    }

    getHtml(posts) {
        if (posts.length < 1) {
            return `<p class="searchErrorMessage">${window.errorMessage}</p>`;
        }

        let html = '';

        for (let i = 0; i < posts.length; i++) {
            html += posts[i].html;
        }

        return html;
    }
}



// WEBPACK FOOTER //
// ./src/pages/news/news.js